<section style="min-height: 200px" [nbSpinner]="loading">
    <div class="content mb-3" *ngIf="registers?.introduction?.publish == '1'">
        <div [innerHTML]="registers?.introduction?.text"></div>
    </div>
    <div class="attached_wrapper">
        <div
            [ngClass]="{ 'col-lg-6': attached.content_type !== 4, 'col-lg-12': attached.content_type === 4 }"
            *ngFor="let attached of registers?.list"
        >
            <article
                [ngClass]="{
                    'attached-card': true,
                    'attached-card-pdf': attached.content_type === 1,
                    'attached-card-text': attached.content_type === 2 || attached.content_type === 3,
                    'attached-card-text-big': attached.content_type === 2,
                    'attached-card-full': attached.content_type === 4
                }"
                [ngSwitch]="attached.content_type"
            >
                <!-- PDF -->
                <ng-container *ngSwitchCase="1">
                    <a [href]="attached.link_document" target="_blank" rel="noreferrer noopener">
                        <h3 class="attached-card-title">
                            {{ attached.description }}
                        </h3>
                        <div class="attached-card-footer">
                            <span>{{ attached.dt_document }}</span>
                            <ng-container [ngSwitch]="attached.document_type">
                                <ng-container *ngSwitchCase="1">
                                    <img
                                        src="/assets/images/pdf.png"
                                        alt="{{ 'GENERAL.DOWNLOAD-FILE' | translate }}"
                                        width="24px"
                                    />
                                </ng-container>
                                <ng-container *ngSwitchCase="2">
                                    <img
                                        src="/assets/images/word.png"
                                        alt="{{ 'GENERAL.DOWNLOAD-FILE' | translate }}"
                                        width="24px"
                                    />
                                </ng-container>
                                <ng-container *ngSwitchCase="3">
                                    <img
                                        src="/assets/images/excel.png"
                                        alt="{{ 'GENERAL.DOWNLOAD-FILE' | translate }}"
                                        width="24px"
                                    />
                                </ng-container>
                            </ng-container>
                        </div>
                        <!-- <div class="attached-card-pdf-hover">
                            <span>Ver PDF</span>
                            <img
                                src="/assets/images/pdf.png"
                                alt="Ver PDF"
                                width="42"
                                *ngIf="attached.content_type === 1"
                            />
                        </div> -->
                    </a>
                </ng-container>

                <!-- Texto Grande -->
                <ng-container *ngSwitchCase="2">
                    <div class="attached-card-link" (click)="onCardClick(attached)">
                        <h3 class="attached-card-title">
                            {{ attached.description }}
                        </h3>
                        <div class="attached-card-content" [innerHTML]="attached.text_limit"></div>
                        <div class="attached-card-footer">
                            <span>{{ attached.dt_document }}</span>
                            <div class="attached-card-button">
                                {{ "GENERAL.VIEW-MORE" | translate }} <fa-icon [icon]="arrowRightIcon"></fa-icon>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Texto -->
                <ng-container *ngSwitchCase="3">
                    <h3 class="attached-card-title">{{ attached.description }}</h3>
                    <div class="attached-card-content" [innerHTML]="attached.text"></div>
                    <div class="attached-card-footer">
                        <!-- prettier-ignore -->
                        <span class="attached-card-date">{{ attached.dt_document }}</span>
                    </div>
                </ng-container>
                <!-- Texto -->
                <ng-container *ngSwitchCase="4">
                    <h3 class="attached-card-title">{{ attached.description }}</h3>
                    <div
                        class="attached-card-content"
                        [innerHTML]="sanitizer.bypassSecurityTrustHtml(attached.text_full)"
                    ></div>
                </ng-container>
            </article>
        </div>
    </div>
</section>
